export const getPermittedFunctionalities = (functionalities, permissions) => {
  return permissions.reduce((permissions, permission) => {
    const functionality = functionalities.find(item => {
      return item.functionality === permission.alias
    })

    if (functionality) {
      return [...permissions, functionality]
    } else {
      return [...permissions]
    }
  }, [])
}

export const can = (functionality, permissions) => {
  return !!permissions.find(item => {
    return item.alias === functionality
  })
}



// WEBPACK FOOTER //
// ./src/utils/permissions.js